module.exports = __webpack_public_path__ + "img/Guam.eb9a1c61.svg";